function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.488 7.404c.236.34.165.057.165 6.855a.74.74 0 001.183.593c2.09-1.576 2.508-1.713 2.508-2.45 0-4.954-.057-4.676.166-4.998l3.394-4.62H2.094l3.394 4.62zM14.186.377a.698.698 0 00-.62-.377H1.431a.7.7 0 00-.574 1.102l.59.802H13.55c.533-.726.89-1.04.636-1.527z",
  fill: "#fff"
});

function SvgIconFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref);
}

export default SvgIconFilters;